export const ADD_TO_FORM = 'ADD_TO_FORM';
export const RESET_FORM = 'RESET_FORM';
export const SAVE_USERNAME = 'SAVE_USERNAME';



// WEBPACK FOOTER //
// ./src/store/modules/registration/mutations.js